import { ManText, ManDropdownMenu,ManSelect,ManSelectItem,ManSpinner } from "@craft-design-system/core-components-react";


const Shimmer_graph_man = ({ loadingProgress = 0 }) => {
    const progressPercentage = Math.round(loadingProgress);
    
    return (
            <div className="card-graph-shimmer">
                <div style={{ textAlign: 'center', padding: '20px' }}>
                    <ManSpinner size="l" variant="standard"></ManSpinner>
                    <div style={{ marginTop: '20px' }}>
                        <ManText variant="body-l" style={{ color: '#666', marginBottom: '12px', fontWeight: '500' }}>
                            Loading data... {progressPercentage}%
                        </ManText>
                        <div style={{ 
                            width: '250px', 
                            height: '10px', 
                            backgroundColor: '#f0f0f0', 
                            borderRadius: '5px',
                            margin: '0 auto',
                            overflow: 'hidden',
                            border: '1px solid #e0e0e0'
                        }}>
                            <div style={{
                                width: `${progressPercentage}%`,
                                height: '100%',
                                background: 'linear-gradient(90deg, #007bff 0%, #0056b3 100%)',
                                borderRadius: '5px',
                                transition: 'width 0.4s ease-out'
                            }}></div>
                        </div>
                    </div>
                </div>
        </div>
    )
}

export default Shimmer_graph_man;